import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Device} from '../../classes/device/device';
import {StatesService} from '../state/states.service';
import {AuthenticationService} from '../authentication/authentication.service';
import {map} from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private http: HttpClient, private stateService: StatesService, private authenticationService: AuthenticationService) {
  }

  public getDeviceList(id: number, active: boolean, available: boolean = false, device_type: number = 0, device_all_level: boolean = false) {
    let deviceType: string = device_type !== 0 ? '&device_type_id=' + device_type : '';
    let deviceAvailable: string = available ? '&available=1' : '';
    let overrideLevel: string = device_all_level ? '&override_level=1' : '';
    return this.http.get(`devices?active=` + (active ? 1 : 0) + `&level=` + id + deviceType + deviceAvailable + overrideLevel)
      .pipe(map((data: any) => {
        data.forEach((d) => {
          d.device_type = d.device_type.type;
          d.project_name = this.getProjectDeviceName(d);
          d.location_name = this.getLocationDeviceName(d);
          d.parent_device = this.getParentDeviceUid(d);
          d.parent_type = this.getParentDeviceType(d);
          d.parent_id = this.getParentDeviceId(d);
          d.children_device = this.getChildrenDevice(d);
          d.level_name = this.getDeviceLevelName(d);
          d.selector = false;
        });
        return data;
      })
    );
  }

  public getDevice(deviceId: number) {
    return this.http.get(`devices/` + deviceId);
  }

  public getChildrenAvailable(typeParent: number) {
    return this.http.get(`devices-types/` + typeParent + `/children-available?level=` + this.stateService.stateLevel);
  }

  public postDevice(device: Device) {

    return this.http.post(`devices`, device);

  }

  public patchDevice(deviceId: number, device: Device, generateLocation?: boolean) {
    const queryString = 'boolean' === typeof generateLocation ? '?generate-location=' + generateLocation : '';
    return this.http.patch(`devices/` + deviceId + queryString, device);
  }

  public patchDevicesCollection(levelId: number, devicesCollection: number[]) {
    let body = {
      level: levelId,
      devices: devicesCollection
    };
    return this.http.patch(`devices-collection`, body);
  }

  deleteDevice(deviceId: number) {
    return this.http.delete(`devices/` + deviceId);
  }

  public getDevicesAvailableByDevicesType(typeDevice: number, projectId: number) {
    let deviceTypeList: number[] = [2, 3, 4];
    let projectFilter = (projectId && deviceTypeList.includes(typeDevice)) ? '&project=' + projectId : '';
    return this.http.get(`devices-types/` + typeDevice + `/devices-available?level=` + this.stateService.stateLevel + projectFilter);
  }

  public getConfigurationForGateway(deviceUID: number) {
    const body = {
      action: 'getGatewayConfigByUid',
      data: {
        uid: deviceUID
      }
    };
    return this.http.post('application.php', body);
  }

  public getConfigurationForSPCU(deviceId: number, version: number = null) {
    let versionSoftware = version !== null ? version : 5.2;
    return this.http.get(`devices/spcu/config/id/` + deviceId + `?version=` + versionSoftware);
  }

  public getDeviceBatchImportTemplate(deviceType: string) {
    return this.http.get('devices/import/template/' + deviceType, {responseType: 'blob'});
  }

  public postDeviceBatchImport(data: FormData) {
    return this.http.post('devices/import/insert', data);
  }

  public getDeviceViaUID(UID: number) {
    return this.http.get('devices/uid/' + UID);
  }

  private getProjectDeviceName(device) {
    return device.project_device_location ? device.project_device_location.project.name :
      (device.project_device_assignement ? device.project_device_assignement.project.name :
          (device.parent && device.parent.project_device_assignement ? device.parent.project_device_assignement.project.name : '-')
      );
  }

  private getLocationDeviceName(device) {
    return device.project_device_location ? device.project_device_location.name : '-';
  }

  private getDeviceLevelName(device) {
    return device.level ? device.level.name : '-';
  }

  private getParentDeviceUid(device) {
    return device.parent ? device.parent.uid : '-';
  }

  private getParentDeviceType(device) {
    return device.parent ? device.parent.device_type.type : null;
  }

  private getParentDeviceId(device) {
    return device.parent ? device.parent.id : null;
  }

  private getChildrenDevice(device) {
    return device.children ? device.children : [];
  }

}
